import { useEffect } from "react";
import { useEmployeeAuth } from "./AdminProvider";
import { useNavigate } from "react-router-dom";
export const RequireEmployee = ({ children }) => {
  const auth = useEmployeeAuth();
  const navigate = useNavigate();
  //   console.log("Entrado en require employee");
  // useEffect(()=>{
  //     if (!auth.isAuth) auth.logout()
  // }, [auth])
  // // return(auth.isAuth?children:auth.logout())
  // return children
  console.log(auth);
  if (!auth.isAuth) auth.logout();
  else return children;
};
